import React from 'react';

const EmptyView = (): React.JSX.Element => (
	<>{/* Because of the system dashboard, there can never be no dashboard */}</>
);

export default EmptyView;
